<template>
  <v-container>
    <v-row dense>
      <v-col v-for="item in items" :key="item.id" :cols="2">
        <v-card class="mx-auto" max-width="344" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1">
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-actions>
            <v-btn outlined rounded text primary :href="item.href">
              Details
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon @click="showExtras(item.id)">
              <v-icon>{{
                show && showId == item.id
                  ? "mdi-chevron-up"
                  : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </v-card-actions>
          <v-expand-transition>
            <div v-show="showId == item.id">
              <v-divider></v-divider>
              <v-card-text>
                {{ item.description }}
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SettingsWH",
  data: () => ({
    show: false,
    showId: 0,
    items: [
      {
        id: 1,
        title: "Brands",
        href: "/wh-brands",
        description: "Brands registry keeps information about all brands.",
      },
      {
        id: 2,
        title: "Categories",
        href: "/wh-categories",
        description:
          "Category registry keeps information about all categories.",
      },
      {
        id: 3,
        title: "Seasons",
        href: "/wh-seasons",
        description:
          "Seasons registry keeps information about all products Seasons.",
      },
      {
        id: 4,
        title: "Genders",
        href: "/wh-gender",
        description: "Gender registry keeps information about all Genders.",
      },
      {
        id: 5,
        title: "Colors",
        href: "/wh-colors",
        description: "Colors registry keeps information about all Colors.",
      },
      {
        id: 6,
        title: "Languages",
        href: "/wh-languages",
        description: "Languages registry keeps information about all Languages.",
      },
    ],
  }),
  methods: {
    showExtras(itemId) {
      if (this.showId == itemId) {
        this.show = false;
        this.showId = 0;
      } else {
        this.showId = itemId;
        this.show = true;
      }
    },
  },
};
</script>
